export const navLinks = [
  { label: 'Home',         href: '#home' },
  { label: 'How it works', href: '/how-it-works' },
  { label: 'Ideas',        href: '#ideas' },
  { label: 'Workouts',     href: '/my-plan?tab=library' },
  { label: 'Nutrition',    href: '/my-plan?tab=nutrition' },
  { label: 'My Plan',      href: '/my-plan?tab=profile&sub=plan' },
  { label: 'Wellbeing',    href: '/my-plan?tab=training&sub=wellbeing' },
  { label: 'Progress',     href: '/my-plan?tab=profile&sub=progress' },
  { label: 'AI Coach',     href: '/my-plan?tab=profile&sub=coach' },
  { label: 'Pricing',      href: '#pricing' },
];

export const heroImage = 'https://images.pexels.com/photos/8032746/pexels-photo-8032746.jpeg';
export const workoutImage = 'https://images.pexels.com/photos/3837754/pexels-photo-3837754.jpeg';

export const systemPoints = [
  'Builds your roadmap around your goal',
  'Sets calories, macros, hydration and recovery emphasis',
  'Uses weekly check-ins to guide progression',
  'Gives you a daily call instead of leaving you to overthink it',
];

export const howItWorks = [
  { n: 1, title: 'Set your target', desc: 'Choose your goal, body data, and direction so the system knows where you are starting from.' },
  { n: 2, title: 'Check in weekly', desc: 'Log your week in under a minute. The plan uses your trend, recovery, adherence and context.' },
  { n: 3, title: 'Follow your daily call', desc: 'Training, calories, hydration and recovery all point back to one clear next step.' },
];

export const whyWorks = [
  { title: 'No fixed plans', desc: 'Your body, energy, and life change. Your plan should change too.' },
  { title: 'Decisions made clearly', desc: 'You do not need to keep second-guessing training, food, or recovery every day.' },
  { title: 'Built around real life', desc: 'The system accounts for consistency, recovery, physiology, hydration and weekly reality.' },
];

export const flowSteps = [
  { title: 'Build My Plan', desc: 'Set up your goal and roadmap' },
  { title: 'Check In Weekly', desc: 'Log progress and recovery' },
  { title: 'Follow Today', desc: 'Use the daily call and stay consistent' },
];

export const flowCards = [
  { title: 'My Plan',    desc: 'The engine. Your roadmap, weekly check-ins, daily call, progress graph, hydration, recovery and plan logic all live here.', cta: 'Open My Plan',    to: '/my-plan?tab=plan' },
  { title: 'Workouts',   desc: 'Exercises and routines that support your personalised plan, from dumbbells and bands to mobility and recovery.',           cta: 'Browse Workouts', to: '/my-plan?tab=library' },
  { title: 'Nutrition',  desc: 'Meal ideas, hydration support and food guidance aligned to the targets your plan gives you.',                              cta: 'See Nutrition',   to: '/my-plan?tab=nutrition' },
  { title: 'Wellbeing',  desc: 'Mental health, recovery and wellbeing support for the days when energy, motivation or life pressure gets in the way.',     cta: 'Open Wellbeing',  to: '/my-plan?tab=training&sub=wellbeing' },
];

export const ideas = [
  {
    title: 'Resistance bands',
    sub: 'Resistance bands \u2014 full-body, joint-friendly',
    img: 'https://images.pexels.com/photos/6740823/pexels-photo-6740823.jpeg',
    sets: '3 rounds \u00b7 8\u201312 reps \u00b7 60s rest',
    cues: 'Keep tension throughout the band path. Control the eccentric (negative) for 2\u20133 seconds. Brace your core to stop the band pulling your posture forward.',
  },
  {
    title: 'Skipping',
    sub: 'Skipping \u2014 5\u201310 minutes for fast cardio',
    img: 'https://images.unsplash.com/photo-1516876345887-6dd74f80787a',
    sets: '5\u20137 rounds \u00b7 45s on / 15s off',
    cues: 'Stay tall, relax shoulders, jump just 2\u20133 cm off the floor. Spin the rope from the wrists, not the arms.',
  },
  {
    title: 'Floor press',
    sub: 'Floor press \u2014 chest & triceps without a bench',
    img: 'https://images.pexels.com/photos/19025674/pexels-photo-19025674.jpeg',
    sets: '4 sets \u00b7 6\u201310 reps \u00b7 90s rest',
    cues: 'Pause the elbows lightly on the floor, drive through the chest, keep wrists stacked over elbows.',
  },
  {
    title: 'Yoga flow',
    sub: 'Yoga flow \u2014 mobility and calm in 10 minutes',
    img: 'https://images.pexels.com/photos/6303447/pexels-photo-6303447.jpeg',
    sets: '10 minutes \u00b7 nasal breathing',
    cues: 'Move with the breath. Inhale to lengthen, exhale to deepen. Stop short of any sharp sensation.',
  },
  {
    title: 'Meal prep',
    sub: 'Meal prep \u2014 clear portions, real food',
    img: 'https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg',
    sets: '4 portions \u00b7 ~30 minutes prep',
    cues: 'A palm of protein, a fist of carbs, two fists of veg, a thumb of fats. Adjust to the targets your plan sets.',
  },
  {
    title: 'Cross-body curl',
    sub: 'Leg-supported cross-body curl \u2014 shoulder-friendly biceps',
    img: 'https://images.pexels.com/photos/15641820/pexels-photo-15641820.jpeg',
    sets: '3 sets \u00b7 10\u201312 reps each side',
    cues: 'Brace elbow on inner thigh. Curl across the body towards the opposite shoulder. Squeeze for 1s at the top.',
  },
];
